import React from "react";

export const ChevronRightIcon = ({}) => {
  return (
    <>
        <path d="M6.36101098,23.7201928 C6.80829437,24.1228847 7.49858438,24.0866123 7.90127636,23.6391916 L7.90127636,23.6391916 L17.7203785,12.7298364 C18.0953876,12.3139168 18.0953876,11.6866281 17.7196971,11.2086634 L17.7196971,11.2086634 L7.9012774,0.360672888 C7.49831284,-0.0866105081 6.80829542,-0.122747664 6.36032952,0.279534393 C5.91440904,0.68454437 5.87895335,1.37046991 6.27987248,1.82048123 L6.27987248,1.82048123 L15.443049,12.0002725 L6.28000877,22.177883 C5.89852218,22.6026647 5.88931778,23.2926145 6.36101098,23.7201928 Z" />
    </>
  );
};
